import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { ApiError } from '@/entities/api-response/types';
import type { User } from '@/entities/user/types';

import { getCurrentUser } from '../api/me';
import { authKeys } from '../model/auth.queryKeys';

export function useCurrentUser(): UseQueryResult<User, ApiError> {
  return useQuery<User, ApiError>({
    queryKey: authKeys.me(),
    queryFn: getCurrentUser,
    retry: false,
    staleTime: 5 * 60_000,
  });
}
